import React, { useEffect, useState } from 'react';
import IPageProps from '../../interfaces/page';
import { currentClass, getLoginInfo, loadCtrlAndDisable, ReacherArPictureName_before } from './tool/helper';
import { IGroupForExpertS } from '../../interfaces/EpModal';
import TopNavPage1 from '../topNav1';
import FooterPage from '../footer';
import ExpertFunctionBar from './component/expertFunctionBar';
import { getAllDrGroup } from '../../services/EP/EpExpertService';
import { getGroupListPass } from '../../services/EP/EPApplyGroupService';
import { PageIndexX } from '../../components/pageIndexX';
import LoadingScreen from './tool/LoadingScreen';
import { checkFileExists } from '../../services/DrFileService';
import saveAs from 'file-saver';
import JSZip from 'jszip';

type ImageStatus = 'ok' | 'broken' | 'missing';
// https://attendance-67917bb.web.app/digit/epStudHome.html
const EpExpertGroupAdmin: React.FunctionComponent<IPageProps> = () => {
    const [currentLoginInfo, setCurrentLoginInfo] = useState<any>();
    const [imageErrors, setImageErrors] = useState<{ [key: string]: boolean }>({});
    const [groupForExpertList, setGroupForExpertList] = useState<IGroupForExpertS[]>();
    /** 下拉式選單 */
    const [selectSectionList, setSelectSectionList] = useState<IGroupForExpertS[]>();
    const [groupForExpertDisplayList, setGroupForExpertDisplayList] = useState<IGroupForExpertS[]>([]);
    const [selectedClassName, setSelectClassName] = useState<string>();
    const [selectedGroup, setSelectedGroup] = useState<string>();
    const [selectedGroupSet, setSelectedGroupSet] = useState<string>();
    const [dropDownExport, setDropDownExport] = useState<{ expAccount: string; groupset: string; exportName: string }[]>([]);
    const [selectedExpert, setSelectedExpert] = useState<{ expAccount: string; groupset: string; exportName: string }>();
    const [selectedSchoolName, setSelectedSchoolName] = useState<string>('(全部學校)');
    const [displayAmount, setDisplayAmount] = useState<number>(1000);
    /**下拉選單 【班級】*/
    const [classNameList, setClassNameList] = useState<string[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    /** 下拉選單 【小組】*/
    const [groupList, setGroupList] = useState<string[]>([]);
    /** 下拉選單 【學校】 */
    const [schoolNameList, setSchoolNameList] = useState<string[]>([]);

    const [lCurrentPage1, setLCurrentPage1] = useState(1);
    const pageName = '小隊基本資料 ';

    const [missingImages, setMissingImages] = useState<string[]>([]);
    const [pdfStatusMap, setPdfStatusMap] = useState<Record<string, boolean>>({});
    const [pptStatusMap, setPptStatusMap] = useState<Record<string, boolean>>({});

    const handleImageError = async (src: string) => {
        try {
            const response = await fetch(src, { method: 'HEAD' });
            if (response.ok) {
                // 有這個圖片檔案，但無法顯示 → 檔案毀損
                setImageStatusMap((prev) => ({ ...prev, [src]: 'broken' }));
            } else {
                // 圖片檔案不存在
                setImageStatusMap((prev) => ({ ...prev, [src]: 'missing' }));
            }
        } catch (error) {
            // 連 HEAD 請求都失敗 → 也當作毀損
            setImageStatusMap((prev) => ({ ...prev, [src]: 'broken' }));
        }
    };

    useEffect(() => {
        loadCtrlAndDisable(sessionStorage.getItem('role') || 'guest', pageName);
    }, []);
    useEffect(() => {
        const fetchPDFStatuses = async () => {
            const map: Record<string, boolean> = {};
            for (const item of groupForExpertDisplayList) {
                const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
                const rsp = await checkFileExists(`/uploads/upload${currentClass}/${item.Groupno}`, 'FinalReport.pdf', '');
                map[pdfPath] = rsp === '檔案已存在.';
            }
            setPdfStatusMap(map);
        };
        fetchPDFStatuses();
    }, [groupForExpertDisplayList]);

    useEffect(() => {
        const fetchPPTStatuses = async () => {
            const map: Record<string, boolean> = {};
            for (const item of groupForExpertDisplayList) {
                const pptPath = `/uploads/upload${currentClass}/${item.Groupno}/report.pptx`;
                const rsp = await checkFileExists(`/uploads/upload${currentClass}/${item.Groupno}`, 'report.pptx', '');
                map[pptPath] = rsp === '檔案已存在.';
            }
            setPptStatusMap(map);
        };
        fetchPPTStatuses();
    }, [groupForExpertDisplayList]);

    useEffect(() => {
        fetchdataGroupInfo();
    }, []);

    const [imageStatusMap, setImageStatusMap] = useState<Record<string, ImageStatus>>({});
    const [imageStatusMap2, setImageStatusMap2] = useState<Record<string, boolean>>({});
    const [isPictureExist, setIsPictureExist] = useState(false);

    // useEffect(() => {
    //     // alert("selectedGroup" +JSON.stringify(selectedGroup))
    //     getIsFileExist();
    // }, [selectedGroup]);

    useEffect(() => {
        const fetchStatuses = async () => {
            const map: Record<string, boolean> = {};
            for (const item of groupForExpertDisplayList) {
                const imagePath = `/uploads/upload${currentClass}/${item.Groupno}/${ReacherArPictureName_before}`;
                const exists = await getIsFileExist(item.Groupno);
                map[imagePath] = exists;
            }
            setImageStatusMap2(map);
        };

        fetchStatuses();
    }, [groupForExpertDisplayList]);

    const getIsFileExist = async (groupNo: string) => {
        const rsp = await checkFileExists(`/uploads/upload${currentClass}/${groupNo}`, ReacherArPictureName_before, '');
        return rsp === '檔案已存在.';
        // alert(`/uploads/upload${currentClass}/${selectedGroup?.groupNo}`)
        if (rsp === '檔案已存在.') {
            setIsPictureExist(true);
        } else {
            setIsPictureExist(false);
        }
    };

    // 選擇的變動時開始塞選
    useEffect(() => {
        setFilterData();
    }, [selectedClassName, selectedGroup, selectedSchoolName, selectedExpert]);

    // 選擇的變動時開始塞選
    useEffect(() => {
        reloadDropDownExport();
    }, [selectedClassName]);

    const reloadDropDownExport = () => {
        let exportlist: { expAccount: string; groupset: string; exportName: string }[] = [];
        let temp: IGroupForExpertS[] = groupForExpertList?.filter((i) => i.Class === selectedClassName) || [];
        exportlist.push({ expAccount: '', groupset: '(全部)', exportName: '回饋組別' });
        temp.forEach((i) => {
            if (!exportlist.find((x) => x.expAccount === i.exportAccount)) exportlist.push({ expAccount: i.exportAccount, groupset: i.GroupSet, exportName: i.ExpertName });
        });

        setDropDownExport(exportlist);
        if (exportlist.length > 0) setSelectedExpert(exportlist[0]);
    };

    const setFilterData = (target?: string) => {
        let result: IGroupForExpertS[] = groupForExpertList || [];
        // 處理年度
        result =
            groupForExpertList?.filter((item) => {
                return selectedClassName?.trim() === item.Class.trim();
            }) || [];
        if (selectedExpert?.exportName !== '回饋組別') {
            result = result.filter((item) => {
                return selectedExpert?.groupset?.trim() === item.GroupSet.trim();
            });
        }

        if (selectedSchoolName !== '(全部學校)' && selectedSchoolName && selectedSchoolName.length > 0) {
            result = result.filter((item) => {
                return selectedSchoolName?.trim() === item.Schoolname.trim();
            });
        }

        // 處理

        setGroupForExpertDisplayList(result);
        setDisplayAmount(result.length);
    };

    const handleImageError2 = (groupNo: string) => {
        // setImageErrors((prev) => ({
        //   ...prev,
        //   [groupNo]: true,
        // }));
    };

    const downloadAllReportsZip = async () => {
        const zip = new JSZip();
        const folder = zip.folder('成果報告');
        let count = 0;

        for (const item of groupForExpertDisplayList) {
            const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
            const hasPDF = pdfStatusMap[pdfPath];
            if (!hasPDF) continue;

            try {
                const response = await fetch(pdfPath);
                if (!response.ok) throw new Error('下載失敗');
                const blob = await response.blob();

                const sanitizedSchool = item.Schoolname?.trim().replace(/[\\/:*?"<>|]/g, '_') || '無學校';
                const sanitizedName = item.Groupname?.trim().replace(/[\\/:*?"<>|]/g, '_') || '無名稱';
                const filename = `${sanitizedSchool}_${item.Groupno}_${sanitizedName}.pdf`;

                folder?.file(filename, blob);
                count++;
            } catch (err) {
                console.warn(`無法下載：${pdfPath}`, err);
            }
        }

        if (count === 0) {
            alert('目前沒有任何可下載的成果報告');
            return;
        }

        const zipBlob = await zip.generateAsync({ type: 'blob' });
        saveAs(zipBlob, '成果報告.zip');
    };

    const downloadAllPresentationsZip = async () => {
        const zip = new JSZip();
        const folder = zip.folder('決賽簡報');
        let count = 0;

        for (const item of groupForExpertDisplayList) {
            const pptPath = `/uploads/upload${currentClass}/${item.Groupno}/report.pptx`;
            const hasPPT = pptStatusMap[pptPath];
            if (!hasPPT) continue;

            try {
                const response = await fetch(pptPath);
                if (!response.ok) throw new Error('下載失敗');
                const blob = await response.blob();

                const sanitizedSchool = item.Schoolname?.trim().replace(/[\\/:*?"<>|]/g, '_') || '無學校';
                const sanitizedName = item.Groupname?.trim().replace(/[\\/:*?"<>|]/g, '_') || '無名稱';
                const filename = `${sanitizedSchool}_${item.Groupno}_${sanitizedName}.pptx`;

                folder?.file(filename, blob);
                count++;
            } catch (err) {
                console.warn(`無法下載：${pptPath}`, err);
            }
        }

        if (count === 0) {
            alert('目前沒有任何可下載的決賽簡報');
            return;
        }

        const zipBlob = await zip.generateAsync({ type: 'blob' });
        saveAs(zipBlob, '決賽簡報.zip');
    };

    const fetchdataGroupInfo = async () => {
        /** 取得登入資料 */
        let currentLoginInfo = getLoginInfo();
        setCurrentLoginInfo(currentLoginInfo);

        try {
            let classNameList: string[] = [];
            let groupNameList: string[] = [];
            let groupSetList: string[] = [];
            // groupNameList.push('全部組別');
            let schoolNameList: string[] = [];
            setIsLoading(true);
            let rsp = (await getAllDrGroup()) as IGroupForExpertS[];
            // console.log("rsp",rsp)
            // 處理下拉式選單
            rsp.forEach((item) => {
                if (!classNameList.includes(item.Class)) {
                    // 設定年度
                    classNameList.push(item.Class);
                }
                if (!groupNameList.includes(item.Groupname)) {
                    groupNameList.push(item.Groupname);
                }

                if (!groupSetList.includes(item.GroupSet)) {
                    groupSetList.push(item.GroupSet);
                }
                if (!schoolNameList.includes(item.Schoolname)) schoolNameList.push(item.Schoolname);
            });
            setClassNameList(classNameList);
            setSelectClassName(classNameList[0]);
            setGroupList(groupNameList);

            setSelectedGroupSet('回饋組別');
            setSchoolNameList(schoolNameList);
            setSelectedGroup('回饋組別');

            setGroupForExpertList(rsp);
            setIsLoading(false);
            console.log('取得專家的隊伍', rsp);
        } catch (error) {}
        // const groupInfo
    };

    useEffect(() => {
        getGroupNoList();
    }, [selectedClassName]);

    const getGroupNoList = () => {
        let result: IGroupForExpertS[] =
            groupForExpertList?.filter((item) => {
                return item.Class === selectedClassName;
            }) || [];

        setSelectSectionList(result);
        setSelectedGroup('回饋組別');
        setSelectedGroupSet('回饋組別');
        setSelectedSchoolName('(全部學校)');
    };

    const renderSchoolOptions = () => {
        const uniqueSchools = [...new Set(selectSectionList?.map((item) => item.Schoolname))];

        return uniqueSchools.map((school) => (
            <li>
                <div className="dropdown-item sel-active" onClick={() => setSelectedSchoolName(school)}>
                    {school}
                </div>
            </li>
        ));
    };

    /** 專家 欄位2 */
    const renderExpertOption = () => {
        const uniqueExperts = [...new Set(selectSectionList?.map((item) => item.GroupSet + '-' + item.ExpertName))];
        if (uniqueExperts.length > 0) {
            //  setSelectedExpert(uniqueExperts[0])
        }

        return dropDownExport.map((expert) => (
            <li>
                <div className="dropdown-item sel-active" onClick={() => setSelectedExpert(expert)}>
                    {expert.groupset}-{expert.exportName}
                </div>
            </li>
        ));
    };
    let lastSchool = ''; // 上一列的學校
    let toggleColor = false; // true/false 對應不同顏色

const exportByApplyName = () => {
    const groupedData: Record<string, { 
        school: string; 
        applyName: string; 
        classCount: string; 
        reportCount: number; 
        groupNoSets: Set<string>; 
    }> = {};

    groupForExpertDisplayList.forEach((item) => {
        const key = `${item.Schoolname}_${item.ApplyName}`;
        if (!groupedData[key]) {
            groupedData[key] = {
                school: item.Schoolname,
                applyName: item.ApplyName,
                classCount: item.classnum,
                reportCount: 0,
                groupNoSets: new Set<string>()
            };
        }

     

        const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
        const hasPDF = pdfStatusMap[pdfPath];
        if (hasPDF) {
            groupedData[key].reportCount += 1;
        }



        if (item.Groupno) {
            groupedData[key].groupNoSets.add(item.Groupno);
        }
    });

    const newWindow = window.open('', '_blank');
    if (!newWindow) return;

    newWindow.document.write(`
        <html>
            <head>
                <meta charset="UTF-8">
                <title>承辦人統計表</title>
                <style>
                    table, th, td {
                        border: 1px solid black;
                        border-collapse: collapse;
                        padding: 5px;
                        text-align: center;
                    }
                    th {
                        background-color: #d9dce6;
                    }
                    .green { color: green; font-weight: bold; }
                    .red { color: red; font-weight: bold; }
                </style>
            </head>
            <body>
                <h2>承辦人統計表</h2>
                <table>
                    <tr>
                        <th>學校</th>
                        <th>承辦人</th>
                        <th>班級數</th>
                        <th>小隊數</th>
                        <th>有成果報告數</th>
                        <th>小隊編號（含連結）</th>
                    </tr>
    `);

    Object.values(groupedData).forEach((item) => {
        const groupSetStr = Array.from(item.groupNoSets).map(groupNo => {
            const pdfPath = `/uploads/upload${currentClass}/${groupNo}/FinalReport.pdf`;
            const hasPDF = pdfStatusMap[pdfPath];
            const colorClass = hasPDF ? 'green' : 'red';
            const linkHTML = hasPDF 
                ? `<a href="${pdfPath}" target="_blank" rel="noopener noreferrer">${groupNo}</a>` 
                : `${groupNo}`;
            return `<div class="${colorClass}">${linkHTML}</div>`;
        }).join('');

        const color = item.reportCount > 0 ? 'green' : 'red';

        newWindow?.document.write(`
            <tr>
                <td>${item.school}</td>
                <td>${item.applyName}</td>
                <td>${item.classCount}</td>
                <td>${item.groupNoSets.size}</td>
                <td style="color: ${color}; font-weight: bold;">${item.reportCount}</td>
                <td>${groupSetStr}</td>
            </tr>
        `);
    });

    newWindow.document.write(`
                </table>
            </body>
        </html>
    `);

    newWindow.document.close();
};

    const exportToHTML = () => {
        const newWindow = window.open('', '_blank');

        if (!newWindow) return;

        newWindow.document.write(`
          <html>
            <head>
              <meta charset="UTF-8">
              <title>資料匯出</title>
              <style>
                table, th, td {
                  border: 1px solid black;
                  border-collapse: collapse;
                  padding: 5px;
                  text-align: center;
                }
              </style>
            </head>
            <body>
              <h2>小隊清單</h2>
              <table>
                <tr>編號、題目、組別、縣市、學校名稱、承辦人、mail、手機、電話、是否有上傳成果報告
                  <th>No.</th>
                  <th>承辦人</th>
                        <th>班級數</th>
                  <th>mail</th> 
                  <th>手機</th>
                  <th>電話</th>
                  <th>小隊編號</th>
                  <th>小隊名稱</th>
                  <th>競賽/學習</th>
                  <th>學校</th>
                  <th>縣市</th>
                  <th>鄉鎮區</th>
                  <th>題目</th>
                  <th>通過</th>
                  <th>圖片-回饋前</th>
                 <th>成果報告</th>
                </tr>
        `);
        groupForExpertDisplayList.forEach((item, index) => {
            if (item.Schoolname !== lastSchool) {
                toggleColor = !toggleColor; // 換學校就切換顏色
                lastSchool = item.Schoolname;
            }
            const bgColor = toggleColor ? '#f5f7fa' : '#ffffff'; // 兩種淡色交錯
            const imagePath = `/uploads/upload${currentClass}/${item.Groupno}/${ReacherArPictureName_before}`;
            const hasImage = imageStatusMap2[imagePath]; // 你原本邏輯中的 status2

            const imageOrText = hasImage
                ? `<img src="${imagePath}" width="100" height="40" onerror="this.outerHTML=&quot;<div style='color:red;'>顯示失敗</div>&quot;">`
                : `<div style="color:gray">📭 尚未上傳</div>`;
            const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
            const hasPDF = pdfStatusMap[pdfPath];

            const pdfHTML = hasPDF ? `<a href="${pdfPath}" target="_blank" rel="noopener noreferrer">查看報告</a>` : `<span style="color:gray;">📭 無檔案</span>`;

            newWindow.document.write(`
              <tr  style="background-color: ${bgColor};">
                <td>${index + 1}</td>
                <td>${item.ApplyName}</td>
                     <td>${item.classnum}</td>
                  <td>${item.Email}</td>
                <td>${item.Mobile}</td>
                <td>${item.Tel}</td>
                <td>${item.Groupno}</td>
                <td>${item.Groupname}</td>
                          <td>${item.CompLearn}</td>
                <td>${item.Schoolname}</td>
                <td>${item.City}</td>
                <td>${item.Area}</td>
                <td>${item.Topic?.replace(/<[^>]*>?/gm, '') || ''}</td>
                <td>${item.FlagOK ? '√' : '--'}</td>
                <td>${imageOrText}</td>
                    <td>${pdfHTML}</td>
              </tr>
            `);
        });
        newWindow.document.write(`
              </table>
            </body>
          </html>
        `);

        newWindow.document.close();
    };

    const openTeamAwardsWindow = async () => {
        try {
            // 撈取資料
            const fetchResult = await getGroupListPass() as any[];
            console.log('撈取到的資料:', fetchResult);
            
            // 打開新視窗
            const newWindow = window.open('', '_blank');
            if (!newWindow) return;

            // 生成 HTML 內容
            newWindow.document.write(`
                <html>
                    <head>
                        <meta charset="UTF-8">
                        <title>TeamAwards 資料</title>
                        <style>
                            body { font-family: Arial, sans-serif; margin: 20px; }
                            table { border-collapse: collapse; width: 100%; margin-top: 20px; }
                            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                            th { background-color: #f2f2f2; font-weight: bold; }
                            tr:nth-child(even) { background-color: #f9f9f9; }
                            .stats { background-color: #e7f3ff; padding: 15px; border-radius: 5px; margin-bottom: 20px; }
                        </style>
                    </head>
                    <body>
                        <h1>TeamAwards 資料查詢</h1>
                        <div class="stats">
                            <h3>資料統計</h3>
                            <p>總筆數: <strong>${fetchResult.length}</strong></p>
                            <p>各組別統計:</p>
                            <ul>
            `);

            // 統計各組別數量
            const typeStats: Record<string, number> = {};
            fetchResult.forEach(item => {
                if (item.type) {
                    typeStats[item.type] = (typeStats[item.type] || 0) + 1;
                }
            });

            // 顯示組別統計
            Object.entries(typeStats).forEach(([type, count]) => {
                newWindow.document.write(`<li>${type}: ${count} 組</li>`);
            });

            newWindow.document.write(`
                            </ul>
                        </div>
                        
                        <h3>詳細資料</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>組別類型</th>
                                    <th>小隊編號</th>
                                    <th>小隊名稱</th>
                                    <th>學校</th>
                                    <th>城市</th>
                                    <th>承辦人</th>
                                    <th>學生數</th>
                                    <th>老師數</th>
                                    <th>是否測試</th>
                                    <th>FlagRevOk</th>
                                    <th>順序</th>
                                </tr>
                            </thead>
                            <tbody>
            `);

            // 顯示資料
            fetchResult.forEach((item, index) => {
                newWindow.document.write(`
                    <tr>
                        <td>${index + 1}</td>
                        <td>${item.type || '--'}</td>
                        <td>${item.GroupNo || '--'}</td>
                        <td>${item.GroupName || '--'}</td>
                        <td>${item.SchoolName || '--'}</td>
                        <td>${item.City || '--'}</td>
                        <td>${item.ApplyName || '--'}</td>
                        <td>${item.StudentCount || '--'}</td>
                        <td>${item.TeacherCount || '--'}</td>
                        <td>${item.IsTest ? '是' : '否'}</td>
                        <td>${item.FlagRevOk || '--'}</td>
                        <td>${item.FinalOrder || '--'}</td>
                    </tr>
                `);
            });

            newWindow.document.write(`
                            </tbody>
                        </table>
                        <br>
                        <p style="color: #666; font-size: 12px;">
                            資料更新時間: ${new Date().toLocaleString()}
                        </p>
                    </body>
                </html>
            `);

            newWindow.document.close();
            
        } catch (error) {
            console.error('撈取資料失敗:', error);
            alert('撈取資料失敗：' + error);
        }
    };

    const openFinalistWindow = async () => {
        try {
            // 撈取資料
            const fetchResult = await getGroupListPass() as any[];
            console.log('撈取到的資料:', fetchResult);
            
            // 篩選決賽名單 (FlagRevOk = 1) 並按 FinalOrder 排序
            const finalists = fetchResult
                .filter(item => item.FlagRevOk == '1' && !item.IsTest)
                .sort((a, b) => {
                    // 按 FinalOrder 排序，如果沒有則放到最後
                    const orderA = a.FinalOrder || 999999;
                    const orderB = b.FinalOrder || 999999;
                    return orderA - orderB;
                });
            
            console.log('決賽名單:', finalists);
            
            // 按組別分組
            const groupedFinalists: Record<string, any[]> = {};
            finalists.forEach(item => {
                const type = item.type || '未分組';
                if (!groupedFinalists[type]) {
                    groupedFinalists[type] = [];
                }
                groupedFinalists[type].push(item);
            });
            
            // 打開新視窗
            const newWindow = window.open('', '_blank');
            if (!newWindow) return;

            // 將下載功能附加到新視窗
            (newWindow as any).downloadFinalistPpts = async () => {
                const button = (newWindow.document.getElementById('downloadBtn') as HTMLButtonElement);
                if (button) {
                    button.disabled = true;
                    button.textContent = '下載中...請稍候';
                }

                const zip = new JSZip();
                let count = 0;

                for (const item of finalists) {
                    const pptPath = `/uploads/upload${currentClass}/${item.GroupNo}/report.pptx`;
                    const rsp = await checkFileExists(`/uploads/upload${currentClass}/${item.GroupNo}`, 'report.pptx', '');
                    const hasPPT = rsp === '檔案已存在.';
                    if (!hasPPT) continue;

                    try {
                        const response = await fetch(pptPath);
                        if (!response.ok) throw new Error('下載失敗');
                        const blob = await response.blob();
                        const sanitizedSchool = item.SchoolName?.trim().replace(/[\\/:*?"<>|]/g, '_') || '無學校';
                        const filename = `${item.FinalOrder}.${item.GroupNo}-${sanitizedSchool}.pptx`;

                        const groupType = item.type || '未分組';
                        const groupFolder = zip.folder(groupType);
                        groupFolder?.file(filename, blob);
                        count++;
                    } catch (err) {
                        console.warn(`無法下載：${pptPath}`, err);
                    }
                }

                if (button) {
                    button.disabled = false;
                    button.textContent = '下載所有決賽簡報 (ZIP)';
                }

                if (count === 0) {
                    alert('沒有可下載的決賽簡報檔');
                    return;
                }

                const zipBlob = await zip.generateAsync({ type: 'blob' });
                saveAs(zipBlob, '決賽簡報.zip');
            };

            // 統計各組別數量
            const typeStats: Record<string, number> = {};
            finalists.forEach(item => {
                if (item.type) {
                    typeStats[item.type] = (typeStats[item.type] || 0) + 1;
                }
            });

            // 生成 HTML 內容
            newWindow.document.write(`
                <html>
                    <head>
                        <meta charset="UTF-8">
                        <title>決賽名單</title>
                        <style>
                            body { font-family: Arial, sans-serif; margin: 20px; }
                            table { border-collapse: collapse; width: 100%; margin-top: 20px; margin-bottom: 30px; }
                            th, td { border: 1px solid #ddd; padding: 8px; text-align: center; }
                            th { background-color: #d9dce6; font-weight: bold; color: #5c71a2; }
                            tr:nth-child(even) { background-color: #f9f9f9; }
                            .stats { background-color: #e7f3ff; padding: 15px; border-radius: 5px; margin-bottom: 20px; }
                            .finalist-header { color: #d63384; text-align: center; margin-bottom: 20px; }
                            .group-header { 
                                color: #0d6efd; 
                                background-color: #f8f9fa; 
                                padding: 15px; 
                                border-left: 5px solid #0d6efd;
                                margin: 30px 0 15px 0;
                                font-size: 20px;
                                font-weight: bold;
                            }
                            .group-stats {
                                color: #6c757d;
                                font-size: 14px;
                                margin-bottom: 10px;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="finalist-header">
                            <h1>🏆 決賽名單 🏆</h1>
                            <p>共 ${finalists.length} 隊入選決賽</p>
                        </div>
                        
                        <div class="stats">
                            <h3>各組別入選統計</h3>
                            <ul>
            `);

            // 顯示組別統計
            Object.entries(typeStats).forEach(([type, count]) => {
                newWindow.document.write(`<li><strong>${type}</strong>: ${count} 隊</li>`);
            });

            newWindow.document.write(`
                            </ul>
                            <div style="text-align: right; margin-top: 15px;">
                                <button id="downloadBtn" onclick="window.downloadFinalistPpts()" style="padding: 10px 15px; font-size: 14px; cursor: pointer; background-color: #28a745; color: white; border: none; border-radius: 5px;">
                                    下載所有決賽簡報 (ZIP)
                                </button>
                            </div>
                        </div>
            `);

            // 按組別顯示決賽名單
            Object.entries(groupedFinalists).forEach(([type, teams]) => {
                newWindow.document.write(`
                    <div class="group-header">
                        ${type} - 決賽名單
                    </div>
                    <div class="group-stats">
                        本組共 ${teams.length} 隊入選決賽
                    </div>
                    
                    <table>
                        <thead>
                            <tr>
                                <th>順序</th>
                                <th>小隊編號</th>
                                <th>小隊名稱</th>
                                <th>學校</th>
                                <th>城市</th>
                                <th>承辦人</th>
                                <th>學生數</th>
                                <th>老師數</th>
                            </tr>
                        </thead>
                        <tbody>
                `);

                // 顯示該組別的決賽隊伍
                teams.forEach((item, index) => {
                    newWindow.document.write(`
                        <tr>
                            <td><strong>${item.FinalOrder || '未設定'}</strong></td>
                            <td>${item.GroupNo || '--'}</td>
                            <td>${item.GroupName || '--'}</td>
                            <td>${item.SchoolName || '--'}</td>
                            <td>${item.City || '--'}</td>
                            <td>${item.ApplyName || '--'}</td>
                            <td>${item.StudentCount || '--'}</td>
                            <td>${item.TeacherCount || '--'}</td>
                        </tr>
                    `);
                });

                newWindow.document.write(`
                        </tbody>
                    </table>
                `);
            });

            newWindow.document.write(`
                        <br>
                        <p style="color: #666; font-size: 12px;">
                            決賽名單更新時間: ${new Date().toLocaleString()}<br>
                            註: 依 FinalOrder 欄位排序，FlagRevOk = 1 的隊伍
                        </p>
                    </body>
                </html>
            `);

            newWindow.document.close();
            
        } catch (error) {
            console.error('撈取決賽名單失敗:', error);
            alert('撈取決賽名單失敗：' + error);
        }
    };

    if (isLoading) {
        return <LoadingScreen />;
    }

    return (
        <>
            <TopNavPage1 />
            <div className="section pt-3">
                <div className="container px-3 px-md-4">
                    <div className="d-flex align-items-center justify-content-between flex-column flex-lg-row">
                        <h5 className="title mb-3 me-3">專題探究競賽</h5>

                        <ExpertFunctionBar />
                    </div>
                    <div className="text-center h5 mt-4 mb-3">小隊基本資料查詢</div>

                    {/* {JSON.stringify(groupForExpertDisplayList)} */}
                    <div className="d-flex flex-wrap justify-content-center align-items-center mb-4">
                        <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedClassName}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                {classNameList.map((item) => (
                                    <li>
                                        <div className="dropdown-item sel-active" onClick={() => setSelectClassName(item)}>
                                            {item}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedGroupSet}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <div className="dropdown-item sel-active">
                                        <b>回饋組別</b>
                                    </div>
                                </li>
                                {selectSectionList?.map((item) => (
                                    <li>
                                        <div className="dropdown-item sel-active" onClick={() => setSelectedGroupSet(item.GroupSet)}>
                                            {item.GroupSet}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div> */}

                        <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedExpert?.groupset + '' + selectedExpert?.exportName}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                {renderExpertOption()}
                            </ul>
                        </div>

                        <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedSchoolName}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <div className="dropdown-item sel-active" onClick={() => setSelectedSchoolName('(全部學校)')}>
                                        <b>(全部學校)</b>
                                    </div>
                                </li>

                                {renderSchoolOptions()}
                            </ul>
                        </div>
                    </div>

                    <div className="card p-4 pt-3" style={{ width: '1350px', overflow: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
<div className="d-flex justify-content-end mb-2" style={{ gap: '8px' }}>
  <button className="btn text-second bg-second" onClick={exportToHTML}>
    小隊成果報告狀態（含圖片）
  </button>
  <button className="btn text-second bg-second" onClick={downloadAllReportsZip}>
    下載所有成果報告（ZIP）
  </button>
  {/* <button className="btn text-second bg-second" onClick={downloadAllPresentationsZip}>
    下載所有決賽簡報（ZIP）
  </button> */}
  <button className="btn text-second bg-second" onClick={openFinalistWindow}>
    決賽名單
  </button>
      <button className="btn text-second bg-second" onClick={exportByApplyName}>
        以承辦人為單位（班級數/有成果報告數）
    </button>
  <button className="btn text-second bg-second" onClick={openTeamAwardsWindow}>
    TeamAwards 資料查詢
  </button>
</div>              </div>
                        共 {groupForExpertDisplayList?.length} 筆
                        <div className="d-flex align-items-end ms-auto">
                            <div className="text-second">顯示筆數</div>
                            <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                                <button className="btn dropdown-toggle fs-16 mb-0 py-0 px-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {displayAmount} 筆
                                </button>

                                {/* <div className="alert alert-warning mt-3">
          有 {missingImages.length} 張圖片載入失敗：
          <ul>
            {missingImages.map((path, i) => (
              <li key={i}>{path}</li>
            ))}
          </ul>
        </div> */}
                                <ul className="dropdown-menu py-3" aria-labelledby="dropdownMenuButton">
                                    {[
                                        { display: '10筆', number: 10 },
                                        { display: '20筆', number: 20 },
                                        { display: '50筆', number: 50 },
                                        { display: '100筆', number: 100 },
                                        { display: '全部', number: groupForExpertDisplayList.length }
                                    ].map((item) => (
                                        <li>
                                            <div className="dropdown-item sel-active" onClick={() => setDisplayAmount(item.number || 1000)}>
                                                {item.display}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="table-responsive  " style={{ width: '1300px', height: '500px', overflow: 'auto' }}>
                            {/* {devTolPrint(imageStatusMap2)} */}
                            <table className="text-sm table table-striped mb-0">
                                <thead>
                                    <tr className="font-weight-bolder text-second" style={{ background: '#d9dce6' }}>
                                        <th className="p-2 text-nowrap">No.</th>
                                        <th className="p-2 text-nowrap" style={{ width: '60px', minWidth: '20px', maxWidth: '60px' }}>
                                            回饋組別
                                        </th>
                                        <th className="p-2 text-nowrap">小隊編號</th>
                                        <th className="p-2 text-nowrap" style={{ width: '120px', minWidth: '80px', maxWidth: '120px' }}>
                                            小隊名稱
                                        </th>
                                        <th className="p-2 text-nowrap" style={{ width: '80px', minWidth: '80px', maxWidth: '80px' }}>
                                            學校
                                        </th>
                                        <th className="p-2 text-nowrap">縣市</th>
                                        <th className="p-2 text-nowrap">鄉鎮區</th>
                                        <th className="p-2 text-nowrap" style={{ width: '180px', minWidth: '120px', maxWidth: '180px' }}>
                                            題目
                                        </th>
                                        <th className="p-2 text-nowrap">通過</th>
                                        <th className="p-2 text-nowrap">備註</th>
                                        {/*  */}
                                        <th className="p-2 text-nowrap">架構圖</th>
                                        <th className="p-2 text-nowrap">成果報告</th>
                                        <th className="p-2 text-nowrap">成果報告(縮圖)</th>
                                        <th className="p-2 text-nowrap">簡報檔</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupForExpertDisplayList.slice((lCurrentPage1 - 1) * displayAmount, lCurrentPage1 * displayAmount).map((item, index) => {
                                        const imagePath = `/uploads/upload${currentClass}/${item.Groupno}/${ReacherArPictureName_before}`;
                                        const status = imageStatusMap[imagePath];
                                        const status2 = imageStatusMap2[imagePath];
                                        // const isExist  =  getIsFileExist (item.Groupno)
                                        return (
                                            <tr>
                                                <td>
                                                    {index + 1}
                                                    {status}
                                                </td>
                                                <td style={{ width: '60px', minWidth: '50px', maxWidth: '60px' }}>{item.GroupSet}</td>
                                                <td style={{ width: '120px', minWidth: '80px', maxWidth: '120px' }}>{item.Groupno}</td>
                                                <td>{item.Groupname}</td>
                                                <td style={{ width: '80px', minWidth: '80px', maxWidth: '80px' }}>{item.Schoolname} </td>
                                                <td>{item.City}</td>
                                                <td>{item.Area} </td>
                                                <td style={{ width: '200px', minWidth: '120px', maxWidth: '200px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: item.Topic }}></div>
                                                    {/* <div>動物排泄物與腸道的關係</div>
                                                  <div>動物排泄物與腸道的關係與因素</div> */}
                                                </td>
                                                <td> {item.FlagOK ? '√' : '--'} </td>
                                                <td></td>
                                                <td>
                                                    {/* {item.Groupno} */}

                                                    {!status2 && <div className="text-muted">📭 尚未上傳</div>}
                                                    {/* {!status && <div className="text-muted">📭 檔案毀損</div>} */}
                                                    {/* {status2 && !imageErrors[item.Groupno] && (     */}

                                                    {status2 && <img className="imgs" src={imagePath} width={50} height={20} alt="" onError={() => handleImageError2(item.Groupno)} />}

                                                    {/* {status2 && <img className="imgs" src={imagePath} width={50} height={20} alt="" />} */}
                                                </td>

                                                <td>
                                                    {(() => {
                                                        const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
                                                        const hasPDF = pdfStatusMap[pdfPath];
                                                        if (hasPDF === undefined) {
                                                            return <span className="text-muted">載入中...</span>;
                                                        } else if (hasPDF) {
                                                            return (
                                                                <a href={pdfPath} target="_blank" rel="noopener noreferrer">
                                                                    查看報告
                                                                </a>
                                                            );
                                                        } else {
                                                            return <span className="text-muted">📭 無檔案</span>;
                                                        }
                                                    })()}
                                                </td>

                                                <td>
                                                    {(() => {
                                                        const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
                                                        const hasPDF = pdfStatusMap[pdfPath];
                                                        if (hasPDF === undefined) {
                                                            return <span className="text-muted">載入中...</span>;
                                                        } else if (hasPDF) {
                                                            return (
                                                                <object
                                                                    data={`/uploads/upload${currentClass}/${item?.Groupno}/${'FinalReport.pdf'}`}
                                                                    type="application/pdf"
                                                                    width="95%"
                                                                    style={{ height: '16vh', overflowX: 'auto' }}
                                                                ></object>
                                                            );
                                                        } else {
                                                            return <span className="text-muted">📭 無檔案</span>;
                                                        }
                                                    })()}
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    {/* <tr>
                                        <td>2</td>
                                        <td>A</td>
                                        <td>EB003-03</td>
                                        <td>B.E.L.K好奇寶寶團 </td>
                                        <td>臺南大學附小 </td>
                                        <td>臺南市</td>
                                        <td>中西區 </td>
                                        <td>
                                            <div>動物也會鳩佔鵲巢？-外來種的分析與探討</div>
                                            <div>動物也會鳩佔鵲巢-外來種的分析與探討</div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                        <PageIndexX frameSize={displayAmount} pageSize={displayAmount} totalRec={groupForExpertDisplayList?.length} currentPage={lCurrentPage1} setCurrentPage={setLCurrentPage1} />
                    </div>

                    <div className="pt-3 mt-4"></div>
                </div>
            </div>
            <FooterPage />
        </>
    );
};

export default EpExpertGroupAdmin;
